"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/* Captured From PROD at http://localhost:3000/en/cars */
var DEFAULT_PROPS = {
  resourceType: 'EditorialDocument_1_0_0',
  lastModified: '1551118869502',
  columns: [{
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/asx.jpg',
      altText: 'ASX',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'ASX',
      paragraph: "Our compact SUV is both practical and economical, so it's bound to fit every aspect of your life and your budget.",
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_ASX_EU_LHD_Catalog_original-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/outlander-phev.jpg',
      altText: 'Outlander PHEV',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'OUTLANDER PHEV',
      paragraph: "The world's bestselling PHEV SUV will reduce your running costs and has superb off-road credentials.",
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19_PHEV_EU_Brochure_Eng_180725_1_WEB.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/eclipse-cross.jpg',
      altText: 'Eclipse Cross',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'Eclipse Cross',
      paragraph: 'Our mid-sized sporty SUV has category-defining looks that make a bold statement on the road.',
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/18.5MY_ECLIPSE_CROSS_EU_LHD_Catalog_reduced.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/space-star.jpg',
      altText: 'Mirage',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'Mirage',
      paragraph: "A compact runabout that's economical to run and easy to park, so it's made for the city.",
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_SPACE_STAR_EU_LHD_Catalog_original-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/l-200.jpg',
      altText: 'L200',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'L200',
      paragraph: 'Not just tough. Really tough. This energetic workhorse is built to move, carry and climb.',
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_EU_L200.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/outlander.jpg',
      altText: 'Outlander',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'OUTLANDER',
      paragraph: "A spacious, versatile SUV that's perfect for families and fully equipped to cope with modern life.",
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_Outlander_EU-LHD_Catalog_original-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/attrage.jpg',
      altText: 'Attrage',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'Attrage',
      paragraph: "This compact saloon car is comfortable, fuel efficient and doesn't skimp on the performance.",
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_Attrage_EU_LHD_Catalog_original-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/montero_sport_brochure_cover.jpg',
      altText: 'MONTERO SPORT',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'MONTERO SPORT',
      paragraph: 'The MONTERO DNA lives on in this new 4X4. Tackles anything from urban streets to the harshest terrain.',
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19_MS_GE_Br_Eng_low_resolution-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }, {
    image: {
      image: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/imiev.jpg',
      altText: 'i-MiEV',
      __typename: 'Image'
    },
    description: {
      mainHeading: 'i-MiEV',
      paragraph: 'The small electric car with the big personality, the i-MiEV is kinder to the planet and your wallet.',
      __typename: 'TextSectionBlock'
    },
    selectButton: null,
    link: {
      url: 'https://cms.prod.mmcmason.co/content/dam/mitsubishi-motors/images/site-images/brochures/brochure_files/19MY_i-MiEV_EU_LHD_Catalog_original-rev-1.pdf',
      label: '',
      __typename: 'NavLink'
    },
    selectStyle: 'downloadPDF',
    downloadPDFText: 'Mostrar PDF descargado (1.9 MB)',
    downloadPDFIcon: 'Download',
    __typename: 'EditorialColumn'
  }],
  __typename: 'Editorial',
  handleFieldChange: function handleFieldChange() {
    return null;
  }
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;